import { Editor } from "grapesjs";
import { CustomComponentSettingsFunction } from ".";

const titleWidgetConfig: CustomComponentSettingsFunction = (
	editor: Editor,
	type: string,
	content?: string,
	settings?: { data: any; setData: (data: any) => void }
) => {
	editor.Components.addType(type, {
		model: {
			defaults: {
				tagName: "div",
				draggable: true,
				droppable: true,
				// Define traits (settings) here
				traits: [
					{
						type: "text", // Type of trait (input)
						label: "Title", // Label for the trait
						name: "titleText", // Name of the trait (used to get/set value)
						changeProp: true,
					},
					{
						type: "link",
						label: "Link",
						name: "link",
					},
				],
				// Define the initial content or data for the component
				// content: data.content,
			},
			init() {
				// this.on("change:titleText", this.handleCustomTextChange);
				this.listenTo(
					this,
					"change:titleText",
					this.handleCustomTextChange
				);
			},
			handleCustomTextChange() {
				const newValue = this.get("titleText");
				// this.set("content", newValue); // Update the content dynamically based on the trait value
				console.log("newValue", newValue);
			},
		},
		view: {
			// Define how the component should render in the canvas
			onRender({ model }) {
				const _content = model.get("content");
				this.el.innerHTML =
					_content || content || "This is a custom component";
			},
		},
	});
};

export default titleWidgetConfig;
